import classNames from 'classnames';
import { type ComponentProps, memo } from 'react';

export type ModalTitleProps = ComponentProps<'h1'>;

export const ModalTitle = memo(({ className, ...restOfProps }: ModalTitleProps) => {
  return (
    <h1
      className={classNames('line-clamp-2 break-words font-semibold text-24 text-gray-12', className)}
      data-testid="MODAL_TITLE"
      {...restOfProps}
    />
  );
});

ModalTitle.displayName = 'ModalTitle';
